import { css } from '@emotion/react';
import type { CSSProperties } from 'react';

export const spaceX = (size: CSSProperties['marginLeft']) =>
	css({ '& > * + *': { marginLeft: size } });

export const spaceY = (size: CSSProperties['marginTop']) =>
	css({ '& > * + *': { marginTop: size } });
